import { Form, Space, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { ISettingItem } from '../../../../../hooks/users';
import ContentCard from '../../../../Common/ContentCard';
import DraggableListItem from '../../../../Common/DraggableListItem';

interface ISettingsList {
  label: string;
  description?: string;
  draggable?: boolean;
  items: ISettingItem[];
}

const SettingsList = ({ label, description, draggable, items }: ISettingsList) => {
  const [form] = useForm();
  const [itemList, setItemList] = useState<ISettingItem[]>([]);

  useEffect(() => {
    setItemList(items.sort((a, b) => a.order - b.order));
  }, [items]);

  useEffect(() => {
    if (!itemList) return;

    const data: { [key: string]: boolean } = {};

    itemList.forEach((item) => {
      data[item.id] = item.active;
    });

    form.setFieldsValue(data);
  }, [itemList]);

  const handleDrop = (droppedItem: DropResult) => {
    if (!droppedItem.destination) return;

    const updatedList = [...itemList];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);

    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

    const reorderedList = updatedList.map((item, index) => ({ ...item, order: index + 1 }));

    setItemList(reorderedList);
  };

  return (
    <Space direction="vertical" size={20}>
      <Space direction="vertical" size={0}>
        <Typography.Title level={3}>{label}</Typography.Title>
      </Space>
      <ContentCard>
        <Form form={form}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="list-container" isDropDisabled={!draggable}>
              {(provided) => (
                <div>
                  <div className="list-container" {...provided.droppableProps} ref={provided.innerRef}>
                    {itemList.map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={`${item.type}${item.id}`}
                        index={index}
                        isDragDisabled={!draggable}
                      >
                        {(draggableProvided) => (
                          <DraggableListItem
                            name={item.id}
                            provided={draggableProvided}
                            text={item.text}
                            draggable={draggable}
                          />
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                  <Typography style={{ color: 'var(--color-gray)' }}>{description}</Typography>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Form>
      </ContentCard>
    </Space>
  );
};

SettingsList.defaultProps = {
  description: undefined,
  draggable: undefined,
};

export default SettingsList;
